export default __webpack_public_path__ + "static/media/son.b8412311.svg";